exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".campusIdDetail[data-v-737972af]{height:100%;min-height:1180px;overflow:scroll}.campusIdDetail .el-select[data-v-737972af]{display:inline-block}.campusIdDetail .el-input[data-v-737972af]{display:inline-block;width:25%}.campusIdDetail .el-button[data-v-737972af]{display:inline-block}.campusIdDetail .el-button+.el-button[data-v-737972af]{margin-left:0}.campusIdDetail .panel[data-v-737972af]{height:90px}.campusIdDetail .title[data-v-737972af]{display:inline-block;width:140px;text-align:right}.campusIdDetail .tips[data-v-737972af]{font-weight:700}.search[data-v-737972af]{margin-left:30px}.datas[data-v-737972af]{margin-top:20px}.el-dialog__body p[data-v-737972af]{line-height:38px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-737972af&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/user/userM/campusIdDetail.vue
// module id = 577
// module chunks = 0